export default function Modal({
  open,
  title,
  children,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  confirmDisabled,
  confirmLoading,
}) {
  if (!open) return null;

  const busy = Boolean(confirmLoading);
  const confirmText = busy ? 'Creating…' : confirmLabel || 'Confirm';

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal-dialog modal-dialog--interstitial" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <div className="modal-header">
          <h2 id="modal-title" className="modal-title">
            {title}
          </h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Close" disabled={busy}>
            ×
          </button>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel || 'Cancel'}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={Boolean(confirmDisabled) || busy}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
